import { Component, Input, OnInit } from '@angular/core';
import { IBService } from '../ib.service';
import { AppService } from 'src/app/app.service';
import { Constants } from 'src/app/shared/utils/constants';

type TUser = 'ib_list' | 'user_list';
interface PaginatorProps {
  q?: string;
  page: number;
  page_size: number;
}

@Component({
  selector: 'fx-discretionary',
  templateUrl: './discretionary.component.html',
  styleUrls: ['./discretionary.component.sass'],
})
export class DiscretionaryComponent implements OnInit {
  @Input() userId;
  @Input() level;
  ibs: any[] = [];
  traders: any[] = [];
  userPageInfo = {
    pageIndex: 1,
    pageSize: 100,
    totalRecord: 0,
  };
  ibPageInfo = {
    pageIndex: 1,
    pageSize: 100,
    totalRecord: 0,
  }
  userPageManual = 1;
  ibPageManual = 1;
  params: Partial<PaginatorProps> = {
    page_size: 100,
    q: '',
  };
  currency = 'jpy';
  constructor(
    private service: IBService,
    private readonly appService: AppService
  ) {}
  ngOnInit(): void {
    this.getListChildData('ib_list');
    this.getListChildData('user_list');
  }
  pageChanged(page: number, type: TUser): void {
    if (type === 'ib_list') {
      this.ibPageInfo.pageIndex = page;
      this.ibPageManual = page;
      this.forcePageIndex(type);
      this.params = {
        ...this.params,
        page: this.ibPageManual
      }
    } else {
      this.userPageInfo.pageIndex = page;
      this.userPageManual = page;
      this.forcePageIndex(type);
      this.params = {
        ...this.params,
        page: this.userPageManual
      }
    }
    this.getListChildData(type);
  }

  forcePageIndex(type: TUser) {
    if (type === 'ib_list') {
      if (!(+this.ibPageManual)) {
        this.ibPageManual = 1;
      }
      const total = this.ibPageInfo.totalRecord;
      const per = this.ibPageInfo.pageSize;
      const page = total / per;
      const [h, t] = String(page).split('.');
      const totalPageAvailable = t ? +h + 1 : +h;
      if (+(this.ibPageManual) > totalPageAvailable) {
        this.ibPageManual = totalPageAvailable;
      }
    } else {
      if (!(+this.userPageManual)) {
        this.userPageManual = 1;
      }
      const total = this.userPageInfo.totalRecord;
      const per = this.userPageInfo.pageSize;
      const page = total / per;
      const [h, t] = String(page).split('.');
      const totalPageAvailable = t ? +h + 1 : +h;
      if (+(this.userPageManual) > totalPageAvailable) {
        this.userPageManual = totalPageAvailable;
      }
    }
  }

  onKeyupPage(evt: KeyboardEvent, type: TUser): void {
    if (evt.code === 'Enter') {
      this.forcePageIndex(type);
      if (type === 'ib_list') {
        this.ibPageInfo.pageIndex = this.ibPageManual;
        this.params.page = this.ibPageManual;
      } else {
        this.userPageInfo.pageIndex = this.userPageManual;
        this.params.page = this.userPageManual;
      }
      this.getListChildData(type);
    }
  }

  private getListChildData(type): void {
    const rootType = (type === 'ib_list') ? 'ib-list' : 'user-list';
    const onlyNumberRegex = /^\d+$/;
    const i = !(onlyNumberRegex.test(String(this.ibPageManual)));
    const u = !(onlyNumberRegex.test(String(this.userPageManual)));
    if(i || u) {
      this.appService.showError('Page number must be a number');
      return void 0;
    }
    this.service.getListChildSpecificByUser(this.userId, rootType, this.params)
      .subscribe(res => {
        if (res.status === Constants.RESPONSE_STATUS.SUCCESS) {
          if (type === 'ib_list') {
            this.ibs = res.data[type];
            const { page, page_size, total } = (res.data as any).paging;
            this.ibPageInfo = {
              pageIndex: page,
              pageSize: page_size,
              totalRecord: total,
            };
            this.ibPageManual = page;
          }
          if (type === 'user_list') {
            this.traders = res.data[type];
            const { page, page_size, total } = (res.data as any).paging;
            this.userPageInfo = {
              pageIndex: page,
              pageSize: page_size,
              totalRecord: total,
            };
            this.userPageManual = page;
          }
        }
      });
  }
}
